<template>
    <div class="af-app af-cf">
        <CustomForm />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Cookie from '@/services/cookie';
    import CustomForm from './components/CustomForm.vue';

    export default {
        name: 'App',
        data() {
            return {};
        },
        async created() {
            if (Cookie.getToken()) {
                await this.$_getMe();
            }
        },
        methods: {
            ...mapActions('me', {
                $_getMe: 'getMe',
            }),
        },
        components: { CustomForm },
    };
</script>
